import React from 'react';
import { FileModel } from 'services/EpdClient';
import FilesList from 'components/v2/file-row/FilesList';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { useComparisonContext } from '../hooks/useComparisonContext';
import { VersionLogFilesListRecord } from '../../version-log/records/VersionLogFilesListRecord';
import { getCellPresentation, CellVariant } from '../diffHighlight';
import { BlockCell } from './comparisonCells';

const toFiles = (raw: unknown): FileModel[] => (Array.isArray(raw) ? raw : []) as FileModel[];

const FilesCell: React.FC<{ label: string; files: FileModel[]; variant?: CellVariant }> = ({ label, files, variant }) => (
  <BlockCell $variant={variant}>
    {files.length > 0 && (
      <>
        <SmartLabel label={label} />
        <FilesList files={files} disabled />
      </>
    )}
  </BlockCell>
);

const FilesListRenderer: React.FC<VersionLogFilesListRecord> = ({ label, propertyId }) => {
  const { left, right, diff, side } = useComparisonContext();
  const leftFiles = toFiles(left.data?.[propertyId]);
  const rightFiles = toFiles(right.data?.[propertyId]);

  // Empty in both versions → nothing to show (must match the row count in FieldPanelRenderer).
  if (leftFiles.length === 0 && rightFiles.length === 0) {
    return null;
  }

  const files = side === 'left' ? leftFiles : rightFiles;
  // FilesCell hides its own content when the list is empty, so only the colour is taken from the diff.
  const { variant } = getCellPresentation(diff[propertyId], side);
  return <FilesCell label={label} files={files} variant={variant} />;
};

export default FilesListRenderer;
